module.exports = {"title":"Hub Settings","datatable":{"name":"Name","outlets":"Outlets","description":"Description"}};